import GenericAPIErrorDisplay, {
  GenericAPIErrorDisplayProps,
} from './GenericAPIErrorDisplay';

export default GenericAPIErrorDisplay;
export type {GenericAPIErrorDisplayProps};
